export class MicroappFittingoutListFilter{
    general: string;
    start_date: string;
    end_date: string;
    type: string;
    status: string;
}